












import { TranslateResult } from 'vue-i18n';
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class LoginForm extends Vue {
  @Prop({ default: 'button' }) type;
  private classes: string = '';
  private text: TranslateResult = '';

  mounted() {
    if (this.type === 'button') {
      this.classes = 'bg-secondary text-white mb-4 px-5';
      this.text = this.$t('registration.findjobs');
    } else {
      this.classes = 'btn-link font-weight-bold  py-4';
      this.text = this.$t('find.jobs.link.text');
    }
  }
}
